import EditorNew from "./Editor";

export default function EditPost() {
    return (
        <>
            <EditorNew />
        </>
    )
}
